import { FIELDS } from '@/pages/PurchaseOrders/components/PurchaseOrderLines/constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
   key: 'purchaseOrderId',
   cell: 'navigation',
   field: FIELDS.PURCHASE_ORDER_ID,
   title: 'Purchase Order No',
   label: 'Purchase Order No',
   sortable: true,
   hidden: false,
   width: 75,
 },{
     key: 'lineNum',
     field: FIELDS.LINE_NUM,
     title: 'Line No',
     label: 'Line No',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'statusName',
     field: FIELDS.STATUS_NAME,
     title: 'Status',
     label: 'Status',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'partNumber',
     field: FIELDS.PART_NUMBER,
     title: 'Part Number',
     label: 'Part Number',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'mfgName',
     field: FIELDS.MFG_NAME,
     title: 'Mfr',
     label: 'Mfr',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCode',
     field: FIELDS.DATE_CODE,
     title: 'Date Code',
     label: 'Date Code',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'needByDate',
     field: FIELDS.NEED_BY_DATE,
     title: 'Need Date',
     label: 'Need Date',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'quantity',
     field: FIELDS.QUANTITY,
     title: 'Qty Ord',
     label: 'Qty Ord',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'qtyReceived',
     field: FIELDS.QTY_RECEIVED,
     title: 'Qty Rcvd',
     label: 'Qty Rcvd',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'qtyRemaining',
     field: FIELDS.QTY_REMAINING,
     title: 'Qty Remain',
     label: 'Qty Remain',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'qtyAvailable',
     field: FIELDS.QTY_AVAILABLE,
     title: 'Qty Avail',
     label: 'Qty Avail',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'qtyAllocated',
     field: FIELDS.QTY_ALLOCATED,
     title: 'Qty Alloc',
     label: 'Qty Alloc',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'qtyRejected',
     field: FIELDS.QTY_REJECTED,
     title: 'Qty Rej',
     label: 'Qty Rej',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'price',
     field: FIELDS.PRICE,
     title: 'Cost',
     label: 'Cost',
     cell: 'formatAmount',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'total',
     field: FIELDS.TOTAL,
     title: 'Total',
     label: 'Total',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'landedPrice',
     field: FIELDS.LANDED_PRICE,
     title: 'Landed Cost',
     label: 'Landed Cost',
     cell: 'formatAmount',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'description',
     field: FIELDS.DESCRIPTION,
     title: 'Description',
     label: 'Description',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'conditionName',
     field: FIELDS.CONDITION_NAME,
     title: 'Condition',
     label: 'Condition',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'countryOfOriginName',
     field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
     title: 'COO',
     label: 'COO',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'nsnNumber',
     field: FIELDS.NSNNUMBER,
     title: 'NSN',
     label: 'NSN',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'package',
     field: FIELDS.PACKAGE,
     title: 'Item Pkg',
     label: 'Item Pkg',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'lotCode',
     field: FIELDS.LOT_CODE,
     title: 'Lot Code',
     label: 'Lot Code',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'leadFree',
     field: FIELDS.LEAD_FREE,
     title: 'RoHS',
     label: 'RoHS',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateDue',
     field: FIELDS.DATE_DUE,
     title: 'Date Due',
     label: 'Date Due',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateShipped',
     field: FIELDS.DATE_SHIPPED,
     title: 'Date Shipped',
     label: 'Date Shipped',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dockDate',
     field: FIELDS.DOCK_DATE,
     title: 'Dock Date',
     label: 'Dock Date',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'altNumber',
     field: FIELDS.ALT_NUMBER,
     title: 'Alt Number',
     label: 'Alt Number',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'internalPn',
     field: FIELDS.INTERNAL_PN,
     title: 'Internal PN',
     label: 'Internal PN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'harmonizedCode',
     field: FIELDS.HARMONIZED_CODE,
     title: 'HTS',
     label: 'HTS',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'scheduleB',
     field: FIELDS.SCHEDULE_B,
     title: 'Schedule B',
     label: 'Schedule B',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'eccn',
     field: FIELDS.ECCN,
     title: 'ECCN',
     label: 'ECCN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'sku',
     field: FIELDS.SKU,
     title: 'SKU',
     label: 'SKU',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'className',
     field: FIELDS.CLASS_NAME,
     title: 'Class',
     label: 'Class',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'categoryName',
     field: FIELDS.CATEGORY_NAME,
     title: 'Category',
     label: 'Category',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'piecePerPkg',
     field: FIELDS.PIECE_PER_PKG,
     title: 'SPQ',
     label: 'SPQ',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'physPkg',
     field: FIELDS.PHYS_PKG,
     title: 'Phys Pkg',
     label: 'Phys Pkg',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'tempRating',
     field: FIELDS.TEMP_RATING,
     title: 'Temp Rating',
     label: 'Temp Rating',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'uom',
     field: FIELDS.UOM,
     title: 'UOM',
     label: 'UOM',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'comments',
     field: FIELDS.COMMENTS,
     title: 'Comments',
     label: 'Comments',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'convertedTotal',
     field: FIELDS.CONVERTED_TOTAL,
     title: 'Conv. Total',
     label: 'Conv. Total',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'convertedPrice',
     field: FIELDS.CONVERTED_PRICE,
     title: 'Conv. Price',
     label: 'Conv. Price',
     cell: 'formatAmount',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'currencyTypeName',
     field: FIELDS.CURRENCY_TYPE_NAME,
     title: 'Currency',
     label: 'Currency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'revision',
     field: FIELDS.REVISION,
     title: 'Revision',
     label: 'Revision',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'tested',
     field: FIELDS.TESTED,
     title: 'Tested',
     label: 'Tested',
     cell: 'checkMArk',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'warrantyName',
     field: FIELDS.WARRANTY_NAME,
     title: 'Warranty',
     label: 'Warranty',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'vendorWarrantyName',
     field: FIELDS.VENDOR_WARRANTY_NAME,
     title: 'V Warranty',
     label: 'V Warranty',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'modifiedByUserFullName',
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'active',
     field: FIELDS.ACTIVE,
     title: 'Active',
     label: 'Active',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'trackingNumber',
     field: FIELDS.TRACKING_NUMBER,
     title: 'TrackingNumber',
     label: 'TrackingNumber',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isInStock',
     field: FIELDS.IS_IN_STOCK,
     title: 'IsInStock',
     label: 'IsInStock',
     cell: 'checkMArk',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isFullLabelTraceable',
     field: FIELDS.IS_FULL_LABEL_TRACEABLE,
     title: 'IsFullLabelTraceable',
     label: 'IsFullLabelTraceable',
     cell: 'checkMArk',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isLotCodeRemoved',
     field: FIELDS.IS_LOT_CODE_REMOVED,
     title: 'IsLotCodeRemoved',
     label: 'IsLotCodeRemoved',
     cell: 'checkMArk',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isMfrCocPackList',
     field: FIELDS.IS_MFR_COC_PACK_LIST,
     title: 'IsMfrCocPackList',
     label: 'IsMfrCocPackList',
     cell: 'checkMArk',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isFranchiseCocPackList',
     field: FIELDS.IS_FRANCHISE_COC_PACK_LIST,
     title: 'IsFranchiseCocPackList',
     label: 'IsFranchiseCocPackList',
     cell: 'checkMArk',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isNotTraceable',
     field: FIELDS.IS_NOT_TRACEABLE,
     title: 'IsNotTraceable',
     label: 'IsNotTraceable',
     cell: 'checkMArk',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
